import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScriptloaderService } from './../../../app/@shared/services/scriptloader.service';
import { hasIn } from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ErrorHandlerService } from './../../../app/@shared/services/errorhandler.service';
import { HttpClient } from '@angular/common/http';
import { loadStripe } from '@stripe/stripe-js';
import { catchError } from 'rxjs';
import { LoaderModule } from '@gridscale/ingrid/components/loader';
import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';

interface iPaymentIntent {
  source: string,
  clientSecret: string,
  stripeToken: string
}

@Component({
    imports: [CommonModule, TranslateModule, LoaderModule],
    selector: 'app-handle-card',
    templateUrl: './handle-card.component.html',
    styleUrls: ['./handle-card.component.scss']
})
export class HandleCardComponent implements OnInit {
  readonly #configService = inject(ConfigService);
  loading = true;
  error = false;
  errorMessage: string | undefined;
  success = false;

  constructor(
    private route: ActivatedRoute,
    private readonly http: HttpClient,
    private scriptLoaderService: ScriptloaderService,
    private translate: TranslateService,
    private readonly errorhandler: ErrorHandlerService
  ) {
  }

  ngOnInit() {
    const intentId: string | null = this.route.snapshot.paramMap.get('intentid');

    if (intentId?.match(/^[a-z0-9_-]+$/i)) {
      this.scriptLoaderService.loadScript('https://js.stripe.com/v3/').subscribe(() => {

        this.http.get<iPaymentIntent>(this.#configService.partnerLegacyApi + '/api/v1/billing/pay/' + intentId).pipe(
          catchError(err => {
            this.error = true;
            this.loading = false;
            if (hasIn(err, ['result', 'response', 'status'])) {
              this.errorMessage = this.translate.instant('sca_error_intent_id_not_found');

            } else {
              this.errorMessage = this.translate.instant('sca_error_generic_error');
            }


            this.errorhandler.captureException(new Error('Stripe: Middleware error Error: ' + JSON.stringify(err)));
            throw err;

          })
        ).subscribe(result => {
          if (result.source) {
            loadStripe(result.stripeToken).then(stripe => {
              stripe?.confirmCardPayment(result.clientSecret, {
                payment_method: result.source
              }).then(result => {
                this.loading = false;

                if (result.error) {
                  this.error = true;
                  if (result.error.message) {
                    this.errorMessage = result.error.message;

                  } else {
                    this.errorMessage = this.translate.instant('sca_error_generic_error');
                  }


                  this.errorhandler.captureException(new Error('Stripe: handleCardPayment() Error: ' + JSON.stringify(result.error)));


                } else if (result.paymentIntent) {
                  this.success = true;

                } else {
                  this.error = true;
                  this.errorMessage = this.translate.instant('sca_error_generic_error');


                  this.errorhandler.captureException(new Error('Stripe: handleCardPayment() Unknown error: ' + JSON.stringify(result)));

                }
              });
            });
          }
        })
      })
    }
  }
}
